var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('v-card',{staticClass:"mx-auto my-12",attrs:{"elevation":"2","max-width":"500","tile":""}},[_c('InvoiceForm')],1),_c('notifications',{attrs:{"group":"app"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }